import React from "react";
import { Alert, Typography } from "@mui/material";
import {
  formatBulkImpactCount,
  getConfirmationLevelLabelFeminine,
  getConfirmationRequirements,
} from "./bulkActionSafety";

/**
 * Aviso na etapa de formulário sobre quantidade impactada e nível de confirmação na próxima etapa.
 */
export default function BulkFormImpactHint({
  count,
  impactVerb = "impactadas",
  irreversible = true,
  forceTypedConfirmation = false,
  minConfirmationLevel = 0,
}) {
  if (!count) return null;

  const req = getConfirmationRequirements(count, { forceTypedConfirmation, minConfirmationLevel });
  const levelLabel = getConfirmationLevelLabelFeminine(req.level);

  return (
    <Alert severity={req.level >= 2 ? "warning" : "info"} variant="outlined">
      <Typography variant="body2" fontWeight={600} gutterBottom>
        {formatBulkImpactCount(count, impactVerb)}.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {irreversible ? "Operação irreversível. " : ""}
        Na próxima etapa será exigida confirmação {levelLabel}
        {req.level >= 1 ? " (inclui digitar a quantidade)" : ""}
        {req.level >= 2 ? ", revisar os IDs" : ""}
        {req.level >= 3 ? ` e digitar ${req.confirmPhrase}` : ""}.
      </Typography>
    </Alert>
  );
}
